import { render, staticRenderFns } from "./PartnerCreate.vue?vue&type=template&id=5e56e82e&scoped=true"
import script from "./PartnerCreate.vue?vue&type=script&lang=js"
export * from "./PartnerCreate.vue?vue&type=script&lang=js"
import style0 from "./PartnerCreate.vue?vue&type=style&index=0&id=5e56e82e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e56e82e",
  null
  
)

export default component.exports